import React, { Component } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import '../../CSS/WeHelpWith.css'
import Counselling from '../Counselling';

const WeHelpWith = () => {
    return (
        <div className="WeHelpWith">
            
            <div className="WeHelpWithDiv">
                
                <div>              
                </div>
                <div className="WeHelpWithServices">
                    <h1>We Help With</h1>
                    <Counselling />   
                </div>
           </div>
        </div>
    )
}

export default WeHelpWith
